import {
  STATE_LOGIN,
  STATE_SIGNUP,
  STATE_FORGOT_PASSWORD,
} from 'components/AuthForm';
import GAListener from 'components/GAListener';
import ForgotPassword from 'components/ForgotPassword';
import { EmptyLayout, LayoutRoute, MainLayout } from 'components/Layout';
import PageSpinner from 'components/PageSpinner';
import AuthPage from 'pages/AuthPage';
import React, { Suspense } from 'react';
import componentQueries from 'react-component-queries';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import './styles/reduction.scss';
import ImagePreview from './pages/Ads Manager/ImagePreview';
import CustomerAccessControls from './pages/CustomerAccessControls';
import DashboardPG from './pages/DashboardPG';
import DashboardCustomer from './pages/DashboardCustomer';
import MyCalendar from './pages/Calender/MyCalendar';
import SimpleLayout from './components/Layout/SimpleLayout';
import PoStatusView from './pages/PoStatusView';
import POStatusUpdate from './pages/POStatusUpdate';
import CustomerBranchmaster from './pages/Master/CustomerBranchMaster';
import TaxMst from './pages/Master/TaxMaster';
import UOMMst from './pages/Master/UomMaster';
import ProductCategoryMst from './pages/Master/CategoryMaster';
import CompanyMaster from './pages/Master/CompanyMaster';
import ProductMaster from './pages/Master/Productmaster';
import CustomerMaster from './pages/Master/CustomerMaster';
import DepartmentMaster from './pages/Master/DepartmentMaster';
import DesignationMaster from './pages/Master/DesignationMaster';
import UserMaster from './pages/Master/UserMaster';
import Quotation from './pages/Quotation';
import QuotationAdd from './pages/QuotationAdd';
import SupplierAccess from './pages/Supplier User Access/Supplieraccess';
import VendorAccess from './pages/Vendor Control Access/VendorAccess';
const CardPage = React.lazy(() => import('pages/CardPage'));
const ChartPage = React.lazy(() => import('pages/ChartPage'));
const Userpage = React.lazy(() => import('pages/User'));
const WidgetPage = React.lazy(() => import('pages/WidgetPage'));
const InspectionPage = React.lazy(() => import('pages/Inspection'));
const InspectionEdit = React.lazy(() => import('pages/InspectionEdit'));
const Dashboard = React.lazy(() => import('pages/Dashboard'));
const Factorordersheet = React.lazy(() => import('pages/Factorordersheet'));
const InspectionReport = React.lazy(() => import('pages/InspectionReport'));

const indent = React.lazy(() => import('pages/Indent'));
const indentcreation = React.lazy(() => import('pages/Createindent'));

const PaymentFollowupScreen = React.lazy(() =>
  import('pages/Paymentfollowupscreen'),
);
const InspectionReportsummary = React.lazy(() =>
  import('pages/InspectionReportSummary'),
);
const Viewdocs = React.lazy(() => import('pages/Viewdocs'));
const logout = React.lazy(() => import('pages/Logout'));
const Approvalview = React.lazy(() => import('pages/Approvalview'));
const acceptview = React.lazy(() => import('pages/Poacceptview'));
const Changepassword = React.lazy(() => import('pages/Changepassword'));
const poaccept = React.lazy(() => import('pages/Poaccept'));
const salesorder = React.lazy(() => import('pages/Salesorder'));
const createsalesorder = React.lazy(() => import('pages/Crearesalesorder'));
const EditSalesOrder = React.lazy(() => import('pages/EditSalesOrder'));
const mothwiseorderstatus = React.lazy(() => import('pages/Misreport'));
const Contract = React.lazy(() => import('pages/ContractDtl'));

const CustomerUserReg = React.lazy(() =>
  import('pages/CustomerUserRegistrartion'),
);
const potracking = React.lazy(() => import('pages/PoTracking'));
const MaterialReceipt = React.lazy(() => import('pages/MaterialReceipt'));
const ViewMaterialReceipt = React.lazy(() =>
  import('pages/ViewMaterialReceipt'),
);
const MATERIAL_RECEIPT_REPORT = React.lazy(() =>
  import('pages/MATERIAL_RECEIPT_REPORT'),
);
const mismaterialissue = React.lazy(() =>
  import('pages/MaterialIssueEntryReport'),
);

const Paymentfollowup = React.lazy(() => import('pages/PaymentFollowupReport'));

const mismatterialreceipt = React.lazy(() =>
  import('pages/MaterialReceiptReport'),
);
const department = React.lazy(() => import('./pages/Departmentmaster'));
const Materailissueentryview = React.lazy(() =>
  import('pages/MaterialissueEntry'),
);
const createMaterialIssueEntry = React.lazy(() =>
  import('pages/CreateMaterialIssueEntry'),
);
const stockreport = React.lazy(() => import('pages/StockReport'));
const UserRole = React.lazy(() => import('pages/UserRole'));
const TermsandConditionMst = React.lazy(() =>
  import('pages/Terms&ConditionMst'),
);
const StateMentOfAccount = React.lazy(() => import('pages/StateMentOfAccount'));
const PaymentReceipt = React.lazy(() => import('pages/PaymentReceipt'));
const Salesinvoicecollection = React.lazy(() =>
  import('pages/SalesInvoiceCollection'),
);
const SalesInvoiceEdit = React.lazy(() =>
  import('pages/SalesInvoiceCollection'),
);
// const Forgotpassword = React.lazy(() => import('components/ForgotPassword'));
const PODemo = React.lazy(() => import('pages/PODemo'));

const QuotationView = React.lazy(() => import('pages/QuotationView'));
const BranchLogMater = React.lazy(() => import('./pages/Master/BranchLogMaster'));

const CompanyLogMater = React.lazy(() => import('./pages/Master/CompanyLogMaster'));
const CompanyBranchMaster = React.lazy(() => import('./pages/Master/CompanyBranchMaster'));

const POTrackingReports = React.lazy(() =>
  import('pages/Reports/POTrackingReports'),
);

const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};

const App = ({ breakpoint }) => (
  <BrowserRouter basename={getBasename()}>
    <GAListener>
      <Switch>
        <LayoutRoute
          exact
          path="/"
          layout={EmptyLayout}
          component={props => <AuthPage {...props} authState={STATE_LOGIN} />}
        />
        <LayoutRoute
          exact
          path="/signup"
          layout={EmptyLayout}
          component={props => <AuthPage {...props} authState={STATE_SIGNUP} />}
        />
        <Route
          exact
          path="/ForgotPassword"
          render={props => (
            <SimpleLayout>
              <ForgotPassword {...props} />
            </SimpleLayout>
          )}
        />

        <MainLayout breakpoint={breakpoint}>
          <Suspense fallback={<PageSpinner />}>
            <Route exact path="/login" component={AuthPage} />
            <Route exact path="/Dashboard" component={Dashboard} />
            <Route exact path="/Approval" component={CardPage} />
            <Route exact path="/viewpo" component={WidgetPage} />
            {/* Indent */}
            <Route exact path="/viewindent" component={indent} />
            <Route exact path="/Createindent" component={indentcreation} />
            <Route exact path="/updateindent/:id" component={indentcreation} />
            <Route exact path="/QuotationView" component={QuotationView} />

            <Route exact path="/user" component={Userpage} />
            <Route
              exact
              path="/PaymentFollowupScreen"
              component={PaymentFollowupScreen}
            />

            <Route
              exact
              path="/Factoryordersheet"
              component={Factorordersheet}
            />
            <Route exact path="/logout" component={logout} />
            <Route exact path="/changepassword" component={Changepassword} />
            <Route exact path="/inspection" component={InspectionPage} />
            <Route exact path="/Purchaseorder" component={ChartPage} />
            <Route exact path="/Purchaseorder/:id" component={ChartPage} />
            <Route exact path="/outstanding" component={InspectionEdit} />
            <Route exact path="/inspection/:id" component={InspectionPage} />
            <Route
              exact
              path="/inspectionsummary"
              component={InspectionReport}
            />
            <Route exact path="/PaymentFollowup" component={Paymentfollowup} />

            <Route
              exact
              path="/inspectionReport"
              component={InspectionReportsummary}
            />
            <Route exact path="/viewdocs" component={Viewdocs} />
            <Route exact path="/approvalview/:id" component={Approvalview} />
            <Route exact path="/changepassowrd" component={Changepassword} />
            <Route exact path="/PoAccept" component={poaccept} />
            <Route exact path="/PoAcceptview/:id" component={acceptview} />
            <Route exact path="/salesorder" component={salesorder} />
            <Route
              exact
              path="/createsalesorder"
              component={createsalesorder}
            />
            <Route
              exact
              path="/createsalesorder/:id/:id1/:id2"
              component={createsalesorder}
            />
            <Route
              exact
              path="/EditSalesOrder/:id"
              component={EditSalesOrder}
            />
            <Route
              exact
              path="/Monthwiseorder"
              component={mothwiseorderstatus}
            />
            <Route exact path="/ContractDtl" component={Contract} />
            <Route exact path="/CustomerUserReg" component={CustomerUserReg} />
            <Route exact path="/potracking" component={potracking} />
            <Route exact path="/materialreceipt" component={MaterialReceipt} />
            <Route
              exact
              path="/materialreceipt/:id"
              component={MaterialReceipt}
            />
            <Route
              exact
              path="/ViewMaterialReceipt"
              component={ViewMaterialReceipt}
            />
            <Route
              exact
              path="/MaterialReceiptReport1"
              component={MATERIAL_RECEIPT_REPORT}
            />
            <Route exact path="/MaterialIssue" component={mismaterialissue} />
            <Route
              exact
              path="/MaterialReceiptReport"
              component={mismatterialreceipt}
            />
            <Route exact path="/Department" component={department} />
            <Route
              exact
              path="/MaterialIssueEntry"
              component={Materailissueentryview}
            />
            <Route
              exact
              path="/CreateMaterialIssueEntry"
              component={createMaterialIssueEntry}
            />
            <Route
              exact
              path="/CreateMaterialIssueEntry/:id"
              component={createMaterialIssueEntry}
            />
            <Route
              exact
              path="/StateMentOfAccount"
              component={StateMentOfAccount}
            />
            <Route exact path="/Payment" component={PaymentReceipt} />
            <Route
              exact
              path="/SalesInvoiceReport"
              component={Salesinvoicecollection}
            />
            <Route
              exact
              path="/SalesInvoiceEdit/:id"
              component={SalesInvoiceEdit}
            />
            <Route exact path="/AdsBanner" component={ImagePreview} />
            <Route exact path="/DashboardCompany" component={DashboardPG} />
            <Route
              exact
              path="/DashboardCustomer"
              component={DashboardCustomer}
            />
            <Route exact path="/Stock" component={stockreport} />
            <Route exact path="/UserRole" component={UserRole} />
            <Route
              exact
              path="/TermsAndCondition"
              component={TermsandConditionMst}
            />

            <Route
              exact
              path="/CustomerAccessControls"
              component={CustomerAccessControls}
            />
            <Route exact path="/PODemo" component={PODemo} />
            <Route exact path="/Calender" component={MyCalendar} />
            <Route exact path="/ForgotPassword2" component={ForgotPassword} />
            <Route exact path="/PoStatusView" component={PoStatusView} />
            <Route exact path="/POStatusUpdate" component={POStatusUpdate} />
            <Route
              exact
              path="/POStatusUpdate/:id"
              component={POStatusUpdate}
            />

            <Route
              exact
              path="/CustomerBranchMst"
              component={CustomerBranchmaster}
            />

            <Route exact path="/TaxMst" component={TaxMst} />
            <Route exact path="/UOMMst" component={UOMMst} />
            <Route
              exact
              path="/ProductCategoryMst"
              component={ProductCategoryMst}
            />
            <Route exact path="/CompanyMaster" component={CompanyMaster} />
            <Route exact path="/ProductMaster" component={ProductMaster} />

            <Route exact path="/CustomerMatser" component={CustomerMaster} />

            <Route
              exact
              path="/DesignationMaster"
              component={DesignationMaster}
            />

           <Route exact path="/DepartmentMst" component={DepartmentMaster} />

            <Route exact path="/UserMaster" component={UserMaster} />   

            <Route exact path="/Quotation" component={Quotation} />

            <Route exactcl path="/QuotationAdd" component={QuotationAdd} />
            <Route exactcl path="/QuotationEdit/:id" component={QuotationAdd} />
            <Route exactcl path="/SupplierAccess" component={SupplierAccess} />
            <Route exactcl path="/BranchLog" component={BranchLogMater} />
            <Route exactcl path="/CompanyLog" component={CompanyLogMater} />
            <Route exactcl path="/CompanyBranch" component={CompanyBranchMaster} />
            <Route exactcl path="/VendorAccess" component={VendorAccess} />

            <Route exactcl path="/POTrackingReports" component={POTrackingReports} />
          </Suspense>
        </MainLayout>
        <Redirect to="/" />
      </Switch>
    </GAListener>
  </BrowserRouter>
);

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: 'xs' };
  }

  if (576 < width && width < 767) {
    return { breakpoint: 'sm' };
  }

  if (768 < width && width < 991) {
    return { breakpoint: 'md' };
  }

  if (992 < width && width < 1199) {
    return { breakpoint: 'lg' };
  }

  if (width > 1200) {
    return { breakpoint: 'xl' };
  }

  return { breakpoint: 'xs' };
};

export default componentQueries(query)(App);
